module.exports = "/images/pfizer_new_logo.png?0e0c9aa475daba3556a078375c04ee28";